<!-- 编辑 -->
<template>
  <div class="box">
    <!-- 路径 -->
    <div class="path">
      <img class="path_img" src="../../../../../assets/images/path.png"/>
      <div class="path_txt">运营管理系统 > 合作伙伴 > 运营投放 > 新增</div>
    </div>
    <!-- 编辑 -->
    <div class="work">
      <!--表单提交-->
      <el-form class="work_form" :model="formData" ref="formData" :rules="formRules" label-position="right" label-width="200px">
        <el-form-item label="应用：" prop="app_id">
          <el-select v-model="formData.app_id" filterable @change="onAhangeApp" placeholder="请选择应用">
            <el-option
                    v-for="app in apps"
                    :key="parseInt(app.app_id)"
                    :label="'(' + app.app_id + ')' + app.app_name"
                    :value="parseInt(app.app_id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="应用类型：" prop="app_type" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'" required>
          <el-select v-model="formData.app_type" filterable placeholder="请选择应用类型">
            <el-option
                    v-for="key in Object.keys(appTypes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + appTypes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="渠道：" prop="channel_id">
          <el-select v-model="formData.channel_id" filterable placeholder="请选择渠道">
            <el-option
                    v-for="item in channels"
                    :key="parseInt(item.channel_id)"
                    :label="'(' + item.channel_id + ')' + item.channel_name"
                    :value="parseInt(item.channel_id)">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放内容：" v-if="formData.app_id && apps && apps.find(item => item.app_id==formData.app_id).business_line == 'quickapp'">
          <el-select v-model="formData.measure_id" filterable clearable placeholder="请选择测评问题">
            <el-option
                    v-for="item in appraises"
                    :key="item.appraise_id"
                    :label="'(' + item.appraise_id + ')' + item.appraise_title"
                    :value="item.appraise_id">
            </el-option>
          </el-select>
          <el-tag>测评</el-tag>
          <br />
          <el-select v-model="formData.book_id" filterable clearable placeholder="请选择小说">
            <el-option
                    v-for="item in books"
                    :key="item.book_id"
                    :label="'(' + item.book_id + ')' + item.book_name"
                    :value="item.book_id">
            </el-option>
          </el-select>
          <el-tag>小说</el-tag>
          <br />
          <el-select v-model="formData.shortplay_id" filterable clearable placeholder="请选择短剧" v-if="!(formData.app_id==30 && formData.app_type==62)">
            <el-option
                    v-for="item in shortplays"
                    :key="item.shortplay_id"
                    :label="'(' + item.shortplay_id + ')' + item.shortplay_name"
                    :value="item.shortplay_id">
            </el-option>
          </el-select>
          <el-select v-model="formData.shortplay_id" filterable clearable placeholder="请选择短剧" v-if="formData.app_id==30 && formData.app_type==62">
            <el-option
                    v-for="item in vshortplays"
                    :key="item.shortplay_id"
                    :label="item.shortplay_name"
                    :value="item.shortplay_id">
            </el-option>
          </el-select>
          <el-tag>短剧</el-tag>
          <br />
          <el-select v-model="formData.cookbook_id" filterable clearable placeholder="请选择菜谱">
            <el-option
                    v-for="key in Object.keys(cookbooks)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + cookbooks[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-tag>菜谱</el-tag>
          <br />
          <el-select v-model="formData.health_class_id" filterable clearable placeholder="请选择养生分类">
            <el-option
                    v-for="key in Object.keys(health_classes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + health_classes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-select v-model="formData.health_id" filterable clearable placeholder="请选择养生文章">
            <el-option
                    v-for="key in Object.keys(healthes)"
                    :key="parseInt(key)"
                    :label="'(' + key + ')' + healthes[key]"
                    :value="parseInt(key)">
            </el-option>
          </el-select>
          <el-tag>养生</el-tag>
          <br />
          <el-tag type="danger">请在测评、小说、短剧、菜谱、养生中仅选择其一</el-tag>
        </el-form-item>
        <el-form-item label="投放平台：" prop="issue_platform">
          <el-select v-model="formData.issue_platform" @change="changedIssuePlatforms" filterable placeholder="请选择投放平台">
            <el-option
                    v-for="item in issuePlatforms"
                    :key="item.issue_platform_tag"
                    :label="item.issue_platform_name"
                    :value="item.issue_platform_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放流量：" prop="issue_flow">
          <el-select v-model="formData.issue_flow" filterable placeholder="请选择投放流量" required>
            <el-option
                    v-for="item in issueFlows"
                    :key="item.issue_flow_tag"
                    :label="item.issue_flow_name"
                    :value="item.issue_flow_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="投放账号：" prop="issue_account" v-if="formData.issue_platform=='oppo' || formData.issue_platform=='vivo' || formData.issue_platform=='huawei' || formData.issue_platform=='toutiao' || formData.issue_platform=='kuaishou' || formData.issue_platform=='qtt' || formData.issue_platform=='gdt' || formData.issue_platform=='uc' || formData.issue_platform=='wifi' || formData.issue_platform=='alipay' || formData.issue_platform=='iqiyi' || formData.issue_platform=='weibo'">
          <el-input clearable v-model="formData.issue_account"></el-input>
        </el-form-item>
        <el-form-item label="投放账号KEY：" prop="issue_account_key" v-if="formData.issue_platform=='huawei' || formData.issue_platform=='wifi'">
          <el-input clearable v-model="formData.issue_account_key"></el-input>
        </el-form-item>
        <el-form-item label="投放回传KEY：" prop="oppo_api_key" v-if="formData.issue_platform=='wifi'">
          <el-input clearable v-model="formData.oppo_api_key"></el-input>
        </el-form-item>
        <el-form-item label="百度账号ID：" prop="issue_account" v-if="formData.issue_platform=='baidu'">
          <el-input clearable v-model="formData.issue_account"></el-input>
        </el-form-item>
        <el-form-item label="百度账号名称：" prop="issue_account_name" v-if="formData.issue_platform=='baidu'">
          <el-input clearable v-model="formData.issue_account_name"></el-input>
        </el-form-item>
        <el-form-item label="OPPO API-ID：" prop="oppo_api_id" v-if="formData.issue_platform=='oppo'">
          <el-input clearable v-model="formData.oppo_api_id"></el-input>
        </el-form-item>
        <el-form-item label="OPPO API-KEY：" prop="oppo_api_key" v-if="formData.issue_platform=='oppo'">
          <el-input clearable v-model="formData.oppo_api_key"></el-input>
        </el-form-item>
        <el-form-item label="百度 aKey：" prop="baidu_api_akey" v-if="formData.issue_platform=='baidu'">
          <el-input clearable v-model="formData.baidu_api_akey"></el-input>
        </el-form-item>
        <el-form-item label="VIVO 数据源：" prop="vivo_api_ds" v-if="formData.issue_platform=='vivo'">
          <el-input clearable v-model="formData.vivo_api_ds"></el-input>
        </el-form-item>
        <el-form-item label="回传类型：" prop="issue_effect_type" v-if="issueEffects && issueEffects.length > 0">
          <el-select v-model="formData.issue_effect_type" filterable clearable @change="changedIssueEffect" placeholder="请选择效果数据回传类型">
            <el-option
                    v-for="item in issueEffects"
                    :key="item.issue_effect_tag"
                    :label="item.issue_effect_name"
                    :value="item.issue_effect_tag">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button class="btn_confirm" type="primary" @click="submitForm('formData')">保存</el-button>
          <el-button class="btn_cancel" @click="onCancel">取消</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
import {
  getCurrDateTime
} from '../../../../../assets/scripts/date2string';

export default {
  data() {
    return {
      // 操作员对象
      operator: null,

      // 应用对象数据
      formData: { 
        app_id: null,
        app_type: null,
        issue_platform: null,
        issue_flow: null,
        channel_id: null,
        measure_id: null,
        book_id: null,
        shortplay_id: null,
        cookbook_id: null,
        health_class_id: null,
        health_id: null,
        issue_account: null,
        issue_account_name: null,
        issue_account_key: null,
        oppo_api_id: null,
        oppo_api_key: null,
        vivo_api_ds: null,
        baidu_api_akey: null,
        issue_effect_type: null,
        issue_time: null,
        issue_status: 1,
        approve_status: 0,
      },
      
      apps: null,             //应用
      channels: null,         //渠道列表
      
      // 投放平台、流量、效果列表
      issuePlatforms: null,
      issueFlows: null,
      issueEffects: null,

      appraises: null,        //测评列表
      books: null,            //小说
      shortplays: null,       //短剧

      vshortplays: null,      //vivo 短剧
      
      // 应用类型
      appTypes: {
        5: "H5",
        61: "OPPO",
        62: "VIVO",
        63: "小米",
        65: "华为",
      },

      // 菜谱
      cookbooks: {
        1:    '红烧肉',
        2:	  '排骨玉米汤',
        3:	  '鱼香肉丝',
        4:	  '炸酱面',
        5:	  '糖醋排骨',
        6:	  '可乐鸡翅',
        7:	  '红焖羊排萝卜',
        8:	  '木须肉',
        9:	  '酸辣土豆丝',
        10:	  '芒果圆子西米露',
        11:   '白菜豆腐煲',
        12:	  '油闷大虾',
        13:	  '煎蛋白菜豆腐汤',
        14:	  '照烧肥牛饭',
        15:   '东北锅包肉',
        16:   '家庭版葡式蛋挞',
        17:	  '秋葵',
        18:	  '三鲜饺子',
        19:	  '咖喱鸡肉饭',
        20:	  '酸辣汤',
        99999:'转盘'
      },

      // 健康养生
      healthes: {
        1:    '警惕亚健康，守护生命活力',
        2:	  '如何呵护颈椎健康',
        3:	  '如何远离腰椎问题',
        4:	  '关注 “工作病”，守护职场健康',
        5:	  '女性经期养生指南',
        6:	  '孕期养生指南',
        7:	  '老年人如何吃才健康？',
        8:	  '老年常见疾病如何预防？',
        9:	  '运动，让老人更健康的秘诀',
        10:	  '老年人觉少正常吗？',
        11:   '解压木鱼真的解压吗',
        12:	  '音乐如何助眠',
        13:	  '摆脱睡眠困扰',
        14:	  '冥想的妙用',
        15:   '冥想，减压神器',
        16:   '音乐，让睡眠更轻松',
        17:	  '常见食材的养生功效',
        18:	  '慢食文化与健康',
        19:	  '胶原蛋白的秘密',
        20:	  '食物搭配禁忌表',
        21:   '暖冬滋补秘籍',
        22:   '顺应节气，吃出健康',
        23:   '如何健康瘦？',
        24:   '八段锦古法养生',
        25:   '上班族如何保持日常运动',
        26:   '日常运动养生小技巧',
        27:   '瑜伽的好处',
        28:   '传统健身的养生智慧',
        29:   '选择合适的户外运动',
        30:   '科学健身',
      },

      health_classes: {
        0:    '食材养生',
        1:	  '冥想疗愈',
        2:	  '运动养生',
        3:	  '养生人群',
      },
      
      // 状态
      issueStatusMap: {
        1: "有效",
        0: "无效"
      },      
      
      // 校验规则
      formRules: {
        app_id: [
          { required: true, message: '请选择应用', trigger: 'blur' }
        ],
        issue_platform: [
          { required: true, message: '请选择投放平台', trigger: 'blur' }
        ],
        issue_flow: [
          { required: true, message: '请选择投放流量', trigger: 'blur' }
        ],
        channel_id: [
          { required: true, message: '请选择渠道', trigger: 'blur' },
        ],
      },

    };
  },
  
  async created() {
    // 从缓存中恢复操作员对象
    let operatorSerial = localStorage.getItem('operator');
    if(operatorSerial==null || operatorSerial==undefined || operatorSerial=='') {
      // 返回登录页面
      this.$router.push('/');
      return;
    }
    this.operator = JSON.parse(operatorSerial);
    // 初始化数据
    this.initApps();
    await this.initChannels();
    await this.initIssuePlatforms();
    await this.initAppraises();
    await this.initBooks();
    await this.initShortplays();
    // 获取复制数据
    if(this.$route.params && this.$route.params.app_issue_id) {
      this.formData.app_id = this.$route.params.app_id;
      this.formData.app_type = this.$route.params.app_type;
      this.formData.issue_platform = this.$route.params.issue_platform;
      this.formData.issue_flow = this.$route.params.issue_flow;
      this.formData.channel_id = this.$route.params.channel_id;
      this.formData.measure_id = this.$route.params.measure_id;
      this.formData.book_id = this.$route.params.book_id;
      this.formData.shortplay_id = this.$route.params.shortplay_id;
      this.formData.issue_effect_type = this.$route.params.issue_effect_type;
      // 加载推广渠道流量
      if(this.formData.issue_platform) {
        this.loadIssueFlows();
        this.loadIssueEffects();
      }
    }      
  },

  methods: {
    // 初始化应用
    async initApps(){
      // 清空当前集合数据
      this.apps = null;
      // 调用接口
      let res = await this.$api.apiPartnerCommonApps({
        operatorId: this.operator.operatorId
      });
      // 应用数据存进data
      this.apps = res.content;
    },

    // 初始化渠道
    async initChannels() {
      // 清空当前渠道
      this.channels = null;
      // 调用接口
      let res = await this.$api.apiPartnerCommonChannels({
        operatorId: this.operator.operatorId
      });
      // 保存结果
      this.channels = res.content;
    },
    
    // 初始化发布平台
    async initIssuePlatforms() {
      // 清空当前渠道
      this.issuePlatforms = null;
      // 调用接口
      let res = await this.$api.apiCommonIssuePlatforms();
      // 保存结果
      this.issuePlatforms = res.content;
    },

    // 修改发布平台
    async changedIssuePlatforms() {
      this.loadIssueFlows(1);
      this.loadIssueEffects(1);
    },

    // 加载发布平台流量类型
    async loadIssueFlows(mode) {
      // 清空当前流量类型
      if(mode == 1) {
        this.formData.issue_flow = null;
      }
      this.issueFlows = null;
      // 调用接口
      let res = await this.$api.apiCommonIssueFlows({issuePlatformTag: this.formData.issue_platform});
      // 保存结果
      this.issueFlows = res.content;
    },
    
    // 加载发布平台效果类型
    async loadIssueEffects(mode) {
      // 清空当前流量类型
      if(mode == 1) {
        this.formData.issue_effect_type = null;
      }
      this.issueEffects = null;
      // 调用接口
      let res = await this.$api.apiCommonIssueEffects({issuePlatformTag: this.formData.issue_platform});
      // 保存结果
      this.issueEffects = res.content;
    },

    // 选择效果数据回传类型
    async changedIssueEffect() {
      this.$forceUpdate();
    },

    // 初始化测评(新)
    async initAppraises() {
      // 清空当前测评
      this.appraises = null;
      // 调用接口
      let res = await this.$api.apiCommonAppraises();
      // 保存结果
      this.appraises = res.content;
    },

    // 初始化小说
    async initBooks() {
      // 清空当前测评
      this.books = null;
      // 调用接口
      let res = await this.$api.apiCommonBooks();
      // 保存结果
      this.books = res.content;
    },

    // 初始化短剧
    async initShortplays() {
      // 加载短剧
      this.shortplays = null;
      let res = await this.$api.apiCommonShortplays();
      this.shortplays = res.content;

      // 加载 vivo 短剧
      this.vshortplays = null;
      res = await this.$api.apiCommonVshortplays();
      this.vshortplays = res.content;
    },
    
    // 修改应用 
    onAhangeApp() {
      // 如果是微信H5业务线，应用类型清空
      if(this.formData.app_id 
          && this.apps.find(item => item.app_id==this.formData.app_id).business_line == 'appraise_pay') {
        this.formData.app_type = null;
      }
    },
    
    // 保存
    async submitForm(form) {
      // 验证表单数据
      this.$refs[form].validate((valid) => {
        if (valid) {
          // 显示页面加载
          const loading = this.$loading({
            lock: true,
            text: 'Processing ......',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)',
            target: '.box'
          });
          // 设置投放时间
          this.formData.issue_time = getCurrDateTime();
          // 调用新增接口
          this.$api.apiPartnerQuickAppIssueAdd(this.formData).then (res => {
            if (res.result === 1) {
              // 请求成功
              this.$message("新增快应用投放成功", "success");
              // 回退
              this.$router.push('/running/partner/issue/index');
            } else {
              this.$message(res.message, "warning");
            }
          });
          // 关闭加载
          loading.close();    
        }
      });
    },

    // 取消
    async onCancel() {
      // 页面回退
      this.$router.go(-1); 
    },
  },
};
</script>

<style lang='scss' scoped>
.box {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: nowrap;
  align-items: center;
  overflow: auto;
}
.path {
  margin: 10px 5px 0px 15px;
  padding: 0px;
  width: 100%;
  height: 20px;
  color: rgb(6, 6, 31);
  font-size: 1rem;
  display: flex;
  justify-content: flex-start;
  flex-wrap: nowrap;
  flex-direction: row;
  align-items: center;
}
.path_img {
  margin-right: 5px;
  height: 15px;
  width: 15px;
}
.path_txt {
  width: 100%;
  height: 20px;
  text-align: left;
}
.work {
  margin: 10px 5px 10px 5px;
  padding: 10px 0px 20px 0px;
  width: 98%;
  height: calc(100% - 20px);
  overflow-y: scroll;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  flex-wrap: wrap;
  background: #fff;
  border-radius: 9px;
  align-items: center;
}
.work_form {
  width: 100%;
  height: auto;
  display: flex;
  flex-wrap: wrap;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
}
.el-form-item {
  margin: 20px 5px 0px 15px;
  width: 96%;
  min-height: 38px;
  height: auto;
}
.el-input {
  width: 300px;
}
.el-select {
  width: 300px;
}
.el-button {
  width: 100px;
}
</style>